/* globals angular, _ */
(function() {
  'use strict';

  function StatusFilterCtrl (
    mdPanelRef,
    moment,
    localStorageService
  ) {
    var ctrl = this;

    ctrl.situacoes = ctrl.filters.data &&
      ctrl.filters.data.situacoes &&
      ctrl.filters.data.situacoes.split(',') ||
      null;
    if(ctrl.filters.data && ctrl.filters.data.classificacoes) {
      var _classificacoes = ctrl.filters.data.classificacoes.split(',')
      for(var i = 0; i < _classificacoes.length; i++) {
        if(_classificacoes[i] == 'Ação pendente') {
          ctrl.acaoPendente = true
        } else if(_classificacoes[i] == 'Notificação de falha') {
          ctrl.notificacao = true
        } else if(_classificacoes[i] == 'Respondido') {
          ctrl.respondido = true
        }
      }
    }

    ctrl.close = function () {
      mdPanelRef.close();
    };

    ctrl.clearFields = function () {
      ctrl.filters.data = {
        situacoes: ctrl.situacoes = null
      };
      ctrl.close();
    };
    ctrl.onSubmit = function (form) {
      if (form.$pristine) {
        ctrl.close();
        return;
      }

      if (!ctrl.filters.data) {
        ctrl.filters.data = {};
      } else {
        delete ctrl.filters.data.situacao
        delete ctrl.filters.data.classificacoes
      }
      var diff = form.$$controls.filter(function(f) { return f.$viewValue } );
      _.forEach(diff, function(field){
        if(Array.isArray(field.$modelValue)) {
          var toSearch = field.$modelValue.filter(function(mod) {
            return mod !== undefined
          });
          ctrl.filters.data[field.$name] = toSearch.join(',');
        } else {
          if(ctrl.filters.data[field.$name]) {
            ctrl.filters.data[field.$name] = ctrl.filters.data[field.$name] + ',' + field.$$attr.value;
          } else {
            ctrl.filters.data[field.$name] = field.$$attr.value;
          }
        }
      });

      var actionName = 'FilterSituation';
      var actionValue = true;
      ctrl.close();
    };
  }

  angular
    .module('mandaeApp')
    .controller('StatusFilterCtrl', StatusFilterCtrl);
}());
